// deps
import React from "react";

// internal-deps
import { SwiggyInstruments, SwiggyInstrumentsPaymentGroup } from "@swiggy-private/payment-ui";

// interfaces
import { PaymentGroupHandlerProps } from "@payment-client/components/show-payments/components/payment-group-handler/interfaces";

// hooks
import { useSwiggyInstrumentsHandler } from "@payment-client/components/show-payments/components/payment-group-handler/hooks/UseSwiggyInstrumentsIHandler";

export interface SwiggyInstrumentsGroupHandlerProps extends Omit<PaymentGroupHandlerProps, "paymentGroup"> {
    paymentGroup: SwiggyInstrumentsPaymentGroup["paymentData"];
}

export function SwiggyInstrumentsGroupHandler(props: SwiggyInstrumentsGroupHandlerProps): React.ReactElement | null {
    const { onSelect, onPay, paymentGroup, ...otherProps } = props;
    const { paymentActions } = useSwiggyInstrumentsHandler(props);

    return <SwiggyInstruments paymentActions={paymentActions} paymentData={props.paymentGroup} {...otherProps} />;
}
